import './index.css';

export default function Footer(){
    return(
        <footer className="footer">
            <section className="content-footer">
                <p className="text-footer">Iglesia Presbiteriana Fundamentalista Bíblica</p>
                <p className="text-footer">Registro publico N° 1794 del 19/12/2008 Ley 19638 RUT: 65.028.018-0, Prieto 260, Constitución</p>
                <p className="text-footer">info@ipfb.cl</p>
            </section>
        </footer>
    );
}